import clsx from 'clsx';
import { type ComponentPropsWithoutRef, type ForwardedRef, forwardRef } from 'react';
import { HeadingContext } from 'react-aria-components';

import { DescriptionContext } from '../Description';

export interface SidebarAlertProps extends ComponentPropsWithoutRef<'div'> {}

/**
 * Sidebar alert component.
 */
export const SidebarAlert = forwardRef(function SidebarAlert(
    props: SidebarAlertProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    const { children, ...rest } = props;
    return (
        <div
            ref={ref}
            {...rest}
            className={clsx('flex flex-col gap-3 rounded-md bg-base p-3 shadow', props.className)}
        >
            <HeadingContext.Provider value={{ level: 3, className: 'text-ui-small' }}>
                <DescriptionContext.Provider value={{ className: '-mt-2 text-ui-small' }}>
                    {children}
                </DescriptionContext.Provider>
            </HeadingContext.Provider>
        </div>
    );
});

export function SidebarAlertActions(props: ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            {...props}
            className={clsx(
                'flex w-full flex-wrap items-center justify-end gap-1',
                props.className
            )}
        />
    );
}
